import { Processo } from '@/models/processo';
import BeneficiarioAuthService from '@/services/beneficiario.auth.service';
import { Route } from 'vue-router';
import ProcessoService from '@/services/processo.service';
import GlobalStore from '@/store/modules/global';
import beneficiarioService from '@/services/beneficiario.service';

export const hasInclusionAndFinishedRegister = async (to: Route, from: Route, next: any) => {
  const { id, processo } = to.params;
  const numeroProcesso = Number(processo);
  const currentBeneficiarioValue = BeneficiarioAuthService.currentBeneficiarioValue();
  // ProcessoService.show(Number(processo)).subscribe(res => {
  //   const processoData = res.data;

  // });
  beneficiarioService
    .beneficiarioProcessoAcompanhamentos(Number(id), Number(numeroProcesso))
    .subscribe(
      res => {
        const processoData = res;
        // @ts-ignore
        const finishedRegister = BeneficiarioAuthService.hasFinishedRegister({
          // @ts-ignore
          ...res.processo,
        });
        const hasInclusionProcess = BeneficiarioAuthService.hasInclusionProcess(
          // @ts-ignore
          processoData.processo.acompanhamentos[0]
        );
        if (!finishedRegister && hasInclusionProcess) {
          next();
        } else {
          GlobalStore.setSnackBar({
            type: 'warning',
            message: 'Esse processo não pode ser alterado.',
            show: true,
          });
          // @ts-ignore
          next({ name: 'passe-livre-detalhe', params: { id } });
        }
      },
      err => {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Algo Deu errado ao tentar buscar os acompanhamentos',
          type: 'error',
        });
      }
    );
};

export const canRegister = async (to: Route, from: Route, next: any) => {
  const beneficiario = BeneficiarioAuthService.currentBeneficiarioValue();

  if (!beneficiario) {
    next();
  } else {
    GlobalStore.setSnackBar({
      type: 'warning',
      message: 'Você já possue um cadastro.',
      show: true,
    });
    next({ name: 'passe-livre-detalhe', params: { id: beneficiario.id } });
  }
};
